import { render, staticRenderFns } from "./WeekdayTile.vue?vue&type=template&id=0b350682&scoped=true&lang=pug"
import script from "./WeekdayTile.vue?vue&type=script&lang=js"
export * from "./WeekdayTile.vue?vue&type=script&lang=js"
import style0 from "./WeekdayTile.vue?vue&type=style&index=0&id=0b350682&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b350682",
  null
  
)

export default component.exports